export default {
  title: "больше о Kozmap".toUpperCase(),
}
